/*
 * Filename: template-publish-panel.component.tsx
 * Description: Landing page for template configuration.
 */

import React, { Component, ReactNode } from 'react';
import { CQAppConstant } from '../../app-constants';
import { observer } from 'mobx-react';
import TemplateConfigurationController from './template-config.controller';
import { CQMasterDataStore } from '../../store/cq-master-data.store';


interface ICQTemplatePublishPanelProps {
    templateLabel: string, templateName: string,
    publishLWC: Function,
    errors: any,
    isValidating: any,
    dirty: any
    isSubmitting: any,
    isValid: any, history: any
}

class CQTemplatePublishPanel extends Component<ICQTemplatePublishPanelProps, { isDownloadButtonOpen: boolean }> {
    private readonly templateConfigCtrl: TemplateConfigurationController;
    constructor(props: Readonly<ICQTemplatePublishPanelProps>) {
        super(props);
        this.templateConfigCtrl = new TemplateConfigurationController();
        this.state = {
            isDownloadButtonOpen: false
        };
    }
    public toggleDownloadButton = () => {
        this.setState({ isDownloadButtonOpen: !this.state.isDownloadButtonOpen });
    }

    public logicToOtherOrgSandbox() {
        this.templateConfigCtrl.loginToDifferentOrg(CQAppConstant.SF_OTHER_ORG_OAUTH_REQUEST_SANDBOX, CQAppConstant.SANDBOX_ENV);
    }

    public logicToOtherOrgProd() {
        this.templateConfigCtrl.loginToDifferentOrg(CQAppConstant.SF_OTHER_ORG_OAUTH_REQUEST_PROD, CQAppConstant.PRODUCTION_ENV);
    }

    public render(): ReactNode {
        const isPublishValid = CQMasterDataStore.OutputConfig.isPublishValid(this.props.templateName);
        return (
            <>
                <div className="slds-grid slds-grid_align-spread bg-white slds-m-bottom_small slds-p-around_small">
                    <div className="slds-media slds-media_center">
                        <div className="slds-media__figure">
                            <span className="slds-avatar slds-avatar_medium">
                                <abbr className="slds-avatar__initials slds-icon-custom-7" title="Sales Cloud">
                                    <i className="cq-icon-layout"></i>
                                </abbr>
                            </span>
                            {/* <i className="cq-icon-layout slds-text-heading_large"></i> */}
                        </div>
                        <div className="slds-media__body">
                            <h2 className="slds-text-heading_medium">{this.props.templateLabel}</h2>
                        </div>
                    </div>
                    <div>
                        <button className="slds-button slds-button_icon slds-button_icon-border-filled slds-m-horizontal_small"
                            onClick={() => {
                                this.props.history.push(CQAppConstant.NAVIGATION.TEMPLATES);
                            }}
                        >
                            <i className="cq-icon-home"></i>
                        </button>
                        <div className="slds-button-group" role="group">
                            <button className="slds-button slds-button_neutral"
                                disabled={!isPublishValid}
                                onClick={() => {
                                    this.props.publishLWC(this.props.templateName);
                                    // this.templateConfigCtrl.publishLWC(this.props.templateName);
                                }}
                            >{CQAppConstant.PUBLISH}</button>
                            <button className="slds-button slds-button_neutral"
                             disabled={!isPublishValid}
                                onClick={() => {
                                    this.templateConfigCtrl.downloadLWC(this.props.templateName);
                                }}>{CQAppConstant.DOWNLOAD}</button>
                            <div className="slds-dropdown-trigger slds-dropdown-trigger_click slds-button_last slds-is-open">
                                <button  disabled={!isPublishValid} onClick={() => {  this.toggleDownloadButton(); }}
                                    className="slds-button slds-button_neutral" aria-haspopup="true" title="Show More">Publish to other Orgs
                               <i className="slds-button__icon slds-button__icon_right cq-icon-down"></i>
                                </button>
                                {
                                    this.state.isDownloadButtonOpen &&
                                    <div className="slds-dropdown slds-dropdown_right slds-dropdown_actions">
                                        <ul className="slds-dropdown__list" role="menu">
                                            <li className="slds-dropdown__item" role="presentation" onClick={() => {
                                                this.toggleDownloadButton();
                                                this.logicToOtherOrgProd();
                                            }}>
                                                <a role="menuitem" >
                                                    <span className="slds-truncate" title="Login to Production">Login to Production</span>
                                                </a>
                                            </li>
                                            <li className="slds-dropdown__item" role="presentation" onClick={() => {
                                                this.toggleDownloadButton();
                                                this.logicToOtherOrgSandbox();
                                            }}>
                                                <a role="menuitem" >
                                                    <span className="slds-truncate" title="Login to Sandbox">Login to Sandbox</span>
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

export default observer(CQTemplatePublishPanel);
